import { defaultClothesConditionsOptions, getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfigFromOptions } from '../filters/size';
import { getDefaultShopConfig } from './default';

const koralSizeOptions = [
  { key: 'XXS', label: 'XXS' },
  { key: 'O/S', label: 'O/S' },
  { key: 'XL', label: 'XL' },
  { key: 'XS', label: 'XS' },
  { key: 'S', label: 'S' },
  { key: 'M', label: 'M' },
  { key: 'L', label: 'L' },
];

export const koralShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: defaultClothesConditionsOptions }),
    getSizeFilterConfigFromOptions({ options: koralSizeOptions }),
  ],
};
